"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faInfoCircle_1 = require("@fortawesome/pro-light-svg-icons/faInfoCircle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var styles_1 = require("./styles");
var SaasFitness = function (_a) {
    var score = _a.score;
    return ((0, jsx_runtime_1.jsxs)(styles_1.DashedDiv, __assign({ mb: 4 }, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["SaaS Fitness ", score] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, paragraph: true, mt: 1 }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faInfoCircle_1.faInfoCircle, color: "grey" }), "\u00A0 Is this the ", (0, jsx_runtime_1.jsx)("strong", { children: "ideal SaaS stack fit" }), " for your people to drive the most value for your business?"] })), (0, jsx_runtime_1.jsxs)("ul", { children: [(0, jsx_runtime_1.jsx)("li", { children: "Rated by your people" }), (0, jsx_runtime_1.jsx)("li", { children: "Value from tool N/A" }), (0, jsx_runtime_1.jsx)("li", { children: "Value for money" }), (0, jsx_runtime_1.jsx)("li", { children: "Usage" }), (0, jsx_runtime_1.jsx)("li", { children: "Critical for business" })] })] })));
};
exports.default = SaasFitness;
